import requester from '@/services/requester'
import env from '@/.env.js'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
    banners: {
        retrieve (parameters) {
            return requester.post(`${BACKEND_API_V1_URL}/banners`, parameters)
        },
    },

    featuredCourses: {
        retrieve (parameters) {
            return requester.post(`${BACKEND_API_V1_URL}/featuredcourses`, parameters)
        },
    },

    featuredPartners: {
        retrieve (parameters) {
            return requester.post(`${BACKEND_API_V1_URL}/featuredpartners`, parameters)
        },
    },
}
